import React, { useState } from 'react';
import styles from './Instructions.module.css';

const Instructions = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.instructions_container}>
      <button
        className={styles.instructions_toggle_small}
        onClick={() => setIsOpen(!isOpen)}
        title="How to play"
      >
        {isOpen ? '✕' : '?'}
      </button>

      {isOpen && (
        <div className={styles.instructions}>
          <p>
            🎯 <strong>Goal:</strong> Place songs in chronological order in your timeline
          </p>
          <p>📱 Scan QR codes to listen, then reveal song details</p>
          <p>🎵 Drag cards to correct timeline positions</p>
          <p>
            👥 <strong>Multiplayer:</strong> Wrong guess = turn switches to other player
          </p>
          <p>
            ✏️ <strong>Names:</strong> Double-click player names to edit them
          </p>
          <p>
            💡 <strong>Drop zones:</strong> Appear when dragging cards
          </p>
        </div>
      )}
    </div>
  );
};

export default Instructions;